<template>
  <div>
    <div class="container" v-if="fill_info == ''">
      <div class="row">
        <div class="col-xs-12 col-md-3">
          <div class="info-box warning"><a href="javascript:void(0)" title="Kitöltési útmutató">Kitöltési útmutató letöltése</a></div>
        </div>

        <!-- Űrlap -->
        <div class="col-xs-12 col-md-9">
          <div class="form-title">{{ form.name }}</div>

          <!-- ------------------------------ Pályázati adatok ------------------------------ -->

          <div v-if="palyazati_adatok.kar != undefined">
            <h5 class="form-block-title-layout-tab" style="margin-top: 0px">
              <span>Pályázati adatok</span>
            </h5>
            <div class="row">
              <div class="col-md-12">
                <inputbox :errors="errors" id="kar" label="A pályázó kar" name="kar" iconclass="fa fa-pencil" v-model="palyazati_adatok.kar"/>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <inputbox :errors="errors" id="oktato" label="A kirándulásért felelős oktató neve" iconclass="fa fa-pencil" name="oktato" v-model="palyazati_adatok.oktato"/>
                <inputbox :errors="errors" id="oktato_email" label="A felelős oktató e-mail címe" iconclass="fa fa-pencil" name="oktato_email" v-model="palyazati_adatok.oktato_email"/>
              </div>
              <div class="col-md-6">
                <inputbox :errors="errors" id="tanszek" label="A pályázó tanszék" iconclass="fa fa-pencil" name="tanszek" v-model="palyazati_adatok.tanszek"/>
                <inputbox :errors="errors" id="oktato_tel" label="A felelős oktató telefonszáma" iconclass="fa fa-pencil" name="oktato_tel" v-model="palyazati_adatok.oktato_tel"/>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <inputbox :errors="errors" id="hallgato" label="A kirándulásért hallgató oktató neve" iconclass="fa fa-pencil" name="hallgato" v-model="palyazati_adatok.hallgato"/>
                <inputbox :errors="errors" id="hallgato_tel" label="A felelős hallgató telefonszáma" iconclass="fa fa-pencil" name="hallgato_tel" v-model="palyazati_adatok.hallgato_tel"/>
              </div>
              <div class="col-md-6">
                <inputbox :errors="errors" id="hallgato_email" label="A felelős hallgató e-mail címe" iconclass="fa fa-pencil" name="hallgato_email" v-model="palyazati_adatok.hallgato_email"/>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <inputbox :errors="errors" id="szak" label="A kiránduláson résztvevő hallgatók szakja" iconclass="fa fa-pencil" name="szak" v-model="palyazati_adatok.szak"/>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <inputbox :errors="errors" id="letszam" label="A kiránduláson résztvevő hallgatók létszáma" iconclass="fa fa-pencil" name="hallgato_tel" v-model="palyazati_adatok.letszam"/>
                <div class="form-group">
                  <label class="form-label">
                    Az utazás módja
                  </label>
                  <select class="form-control" name="utazas_modja" id="utazas_modja" v-model="palyazati_adatok.utazas_modja">
                    <option v-for="(um, i) in utazasi_modok" :value="um.value">{{ um.text }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <inputbox :errors="errors" id="tantargy" label="A kiránduláshoz kapcsolódó tantárgy neve" iconclass="fa fa-pencil" name="hallgato_tel" v-model="palyazati_adatok.tantargy"/>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <inputbox :errors="errors" regexp_filter="[0-9]+" id="koltseg" label="A kirándulás tervezett költsége" iconText="Ft" name="koltseg" v-model="palyazati_adatok.koltseg"/>
                <inputbox :errors="errors" id="helyszin" label="A tanulmányi kirándulás tervezett helyszíne" iconclass="fa fa-pencil" name="helyszin" v-model="palyazati_adatok.helyszin"/>
              </div>
              <div class="col-md-6">
                <inputbox :errors="errors" regexp_filter="[0-9]+" id="tamogatas_osszege" label="Az igényelt támogatás összege" iconText="Ft" name="tamogatas_osszege" v-model="palyazati_adatok.tamogatas_osszege"/>
                <inputbox :errors="errors" regexp_filter="[0-9]+" id="tavolsag" label="A helyszín távolsága Győrtől" iconText="km" name="tavolsag" v-model="palyazati_adatok.tavolsag"/>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <inputbox :errors="errors" id="kezdet" ref="kezdet" :datepicker="true" :datepickeropts="{'maxDate':this.veg}" v-on:onchange="kezdDateChange" label="A kirándulás tervezett kezdete" iconclass="fa fa-pencil" name="kezdet" v-model="palyazati_adatok.kezdet"/>
              </div>
              <div class="col-md-6">
                <inputbox :errors="errors" id="veg" ref="veg" :datepicker="true" :datepickeropts="{'minDate':this.kezdet}" v-on:onchange="vegDateChange" label="A kirándulás tervezett vége" iconclass="fa fa-pencil" name="veg" v-model="palyazati_adatok.veg"/>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <textareabox :errors="errors" cstyle="min-height: 100px" placeholder="" :autogrow="true" iconclass="fa fa-pencil" id="ismerteto" label="A tanulmányi kirándulás rövid ismertetése, szakmai célja" name="ismerteto" v-model="palyazati_adatok.ismerteto"/>
              </div>
            </div>

            <div style="display: flex; justify-content: space-between; align-items: center">
              <button v-on:click="save" type="button" name="kuld" :disabled="!save_enabled" class="button">Beküld</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-show="fill_info != ''">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">{{ form.name }}</div>
          <div class="article-text" v-html="fill_info">{{ fill_info }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';

export default {
  components: {
  },

  data: function() {
    return {
      fill_info: '',
      save_enabled: false,
      errors: [],
      palyazati_adatok: {
        kar: '',
        tanszek: '',
        oktato: '',
        oktato_tel: '',
        oktato_email: '',
        hallgato: '',
        hallgato_tel: '',
        hallgato_email: '',
        szak: '',
        letszam: '',
        tantargy: '',
        koltseg: '',
        tamogatas_osszege: '',
        helyszin: '',
        tavolsag: '',
        kezdet: '',
        veg: '',
        ismerteto: '',
        utazas_modja: 'repulo'
      },
      form: {
        name: 'Tanulmányi kirándulások támogatása',
        id: 0
      },
      utazasi_modok: [
        {
          value: 'repulo',
          text: 'Repülő',
        },
        {
          value: 'vonat',
          text: 'Vonat',
        },
        {
          value: 'busz',
          text: 'Busz',
        },
        {
          value: 'kombinalt',
          text: 'Kombinált',
        }
      ]
    }
  },
  mounted: function() {
  	var _this = this;

    this.$root.ajax('form/urlap_kitoltheto/TanulmanyiKirandulasPalyazat/' + this.$root.user.id, {
      method: 'GET',
      success: function(response) {
        if (response.error == false) {
          if (!response.kitoltheto) {
            _this.fill_info = 'Az űrlap nem tölthető ki.';

          } else {
            _this.$root.ajax('form/getFormByVueComponent/TanulmanyiKirandulasPalyazat', {
              method: 'GET',
              success: function(response) {
                if (response.error == false) {
                  if(response.form != false) {
                    _this.form.name = response.form.name;
                    _this.form.id = response.form.id;
                    _this.save_enabled = true;
                  } else {
                    _this.fill_info = 'Ez a pályázat jelenleg nem beadható!';
                  }
                } else  {
                  swal('Hiba!', response.error, 'error');
                }
              }
            });
          }
        } else {
          swal('Hiba!', response.error, 'error');
        }
      }
    });
  },
  watch: {
  },
  methods: {
    getTooltipDescriptionByKey: function(tkey) {
      var desc = '';
      this.elemleirasok.map(function(el) {
        if (el.tkey == tkey)
          desc = el.tooltip_description;
      });

      return desc;
    },

    getUploadDescriptionByKey: function(tkey) {
      var desc = '';
      this.elemleirasok.map(function(el) {
        if (el.tkey == tkey)
          desc = el.upload_description;
      });

      return desc;
    },

    getElemleirasok: function() {
      var _this = this;
      this.$root.ajax('hatar/elemleirasok/TanulmanyiKirandulas', {
        method: 'GET',
        success: function(response) {
          _this.elemleirasok = response.elemleirasok;
        }
      });
    },

    setPanels: function() {
      var h = $('header').outerHeight() + $('.subpage-head-image').outerHeight() + $('.submenu').outerHeight() + 40 - 20;
      if ($(window).scrollTop() >= h) {
        $('.panels').addClass('fixed').css('width', $('.panels').parents('div').width());
      } else {
        $('.panels').removeClass('fixed').css('width', 'auto');
      }

      // Ha a lábléc megjelenik, akkor a magasságból ki kell vonni a látható lábléc magasságát
      if (($(window).scrollTop() + $(window).innerHeight()) >= $('footer').offset().top) {
        $('.panels').css({
          'max-height': $(window).innerHeight() - 40 - (($(window).scrollTop() + $(window).innerHeight()) - $('footer').offset().top)
        });
      } else {
        $('.panels').css({
          'max-height': $(window).innerHeight() - 40
        });
      }
    },

    kezdDateChange: function() {
      this.$refs.veg.updateDatepicker({'minDate':this.palyazati_adatok.kezdet});
    },

    vegDateChange: function() {
      this.$refs.kezdet.updateDatepicker({'maxDate':this.palyazati_adatok.veg});
    },

    save: function() {
      var _this = this;

      this.errors = [];

      this.$root.ajax('form/ment/tanulmanyi_kirandulas_palyazat/', {
        method: 'POST',
        data: {
          form: this.palyazati_adatok,
          form_id: this.form.id,
          user_id: this.$root.user.id
        },
        success: function(response) {
          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = response.fill_info;
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// tanulmanyi_kirandulas_palyazat.vue?f9951b16